/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/waste-depot.html";

const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);

require("Styles/components/popup/waste-depot.scss");

class WasteDepotView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.event = options.event;

        this.renderResourceButtons(options.html.find(".resource-button-container"));
    }

    getChosenResources()
    {
        let buttons = $(".resource-button-container").find(".selected");
        let resources = [];

        for (let i = 0; i < buttons.length; ++i)
        {
            resources.push($(buttons[i]).data("resource"));
        }

        return resources;
    }

    renderResourceButtons(container)
    {
        container.empty();

        let okButton = null;
        let resources = [
            "resource_red",
            "resource_red",
            "resource_yellow",
            "resource_yellow",
            "resource_purple",
            "resource_purple"
        ];

        setTimeout(() =>
        {
            okButton = this.$element.closest(".modal-content").find(".dialog-confirm-btn");

            okButton.prop("disabled", true);
        }, 1);

        resources = shuffle(resources);

        for (let i = 0; i <= 3; ++i)
        {
            let button = $("<div class='resource-button'>");
            let resource = resources[i + 1];

            let img = "<img src='" + resourceIcons("./" + resource + ".svg") + "' />";

            button.append(img);
            button.data("resource", resource);

            button.click(function()
            {
                if (button.hasClass("disabled"))
                {
                    return;
                }

                if (button.hasClass("selected"))
                {
                    button.removeClass("selected");
                }
                else
                {
                    button.addClass("selected");
                }

                let totalSelected = container.find(".selected").length;

                if (totalSelected === 2)
                {
                    container.find(".resource-button").not(".selected").addClass("disabled");
                    okButton.prop("disabled", false);
                }
                else
                {
                    container.find(".resource-button").not(".selected").removeClass("disabled");
                    okButton.prop("disabled", true);
                }
            });

            container.append(button);
        }

        function shuffle(array)
        {
            let currentIndex = array.length, randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex !== 0)
            {
                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [ array[currentIndex], array[randomIndex] ] = [ array[randomIndex], array[currentIndex] ];
            }

            return array;
        }
    }
}

module.exports = WasteDepotView;



// WEBPACK FOOTER //
// ./app/js/components/popup/waste-depot.js